import { memo } from 'react';
import PropTypes from 'prop-types';

import { useInView } from 'react-intersection-observer';

import { buildPhotoUrl } from '../../utils/images';

import styles from './FullScreenPhotoList.module.scss';

const ROOT_MARGIN_PX = '200px';

const LazyPhoto = memo(({ photo, className, imageClassName, onImageClick }) => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    rootMargin: ROOT_MARGIN_PX,
    threshold: 0
  });

  const content = inView ? (
    <img
      src={buildPhotoUrl(photo.id, photo.verified)}
      alt={photo.caption ? `${photo.caption} - photo` : 'Photo'}
      loading="lazy"
      className={imageClassName}
    />
  ) : (
    <span className={styles['full-screen-photo-list__image-placeholder']} />
  );

  return (
    <div ref={ref} className={className}>
      {onImageClick ? (
        <button
          type="button"
          onClick={() => onImageClick(photo)}
          className={styles['full-screen-photo-list__image-button']}
        >
          {content}
        </button>
      ) : (
        content
      )}
    </div>
  );
});

LazyPhoto.displayName = 'LazyPhoto';

LazyPhoto.propTypes = {
  photo: PropTypes.shape({
    id: PropTypes.string.isRequired,
    caption: PropTypes.string,
    verified: PropTypes.bool
  }).isRequired,
  className: PropTypes.string.isRequired,
  imageClassName: PropTypes.string.isRequired,
  onImageClick: PropTypes.func
};

LazyPhoto.defaultProps = {
  onImageClick: null
};

export default LazyPhoto;
